import { IClient, IOutboundSms, OutboundEmailStatus } from "intake_shared/src/types";
import store from "../store";
import { phone } from "phone";

export async function sendClientTerminationSms(client: IClient, sms_text: string) {
    const userPhoneNumber = phone(client.phone_no);

    const client_sms: IOutboundSms = {
        to: userPhoneNumber.phoneNumber || "",
        text: sms_text || "",
    };
    await store.queueSms(client_sms, OutboundEmailStatus.PENDING);
}
